// extracted by mini-css-extract-plugin
module.exports = {"decimal":"GetPrice_decimal__248ah"};